export const getHtmlText = (html) => {
  const dom = document.createElement('div')
  dom.innerHTML = html
  return dom.textContent.length > 28 ? `${dom.textContent.substring(0, 28)}...` : dom.textContent
}
export const getMessageFirstLine = (html) => {
  let index = html.indexOf('</p>')
  const dom = document.createElement('div')
  dom.innerHTML = html.substring(0, index) + '</p>'
  return dom.textContent
}

export default {
  getHtmlText,
  getMessageFirstLine
}
